import React from 'react';
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
  IconButton
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { Link } from 'react-router-dom';

const NewsCard = ({ article, selectedSite, onFilterBySite, onSaveArticle, isSaved }) => {
  const formattedDate = article.created_at
    ? new Date(article.created_at).toISOString().split("T")[0]
    : "";
  const siteName = article.SITE_NAME || "NEWS";

  const handleSiteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onFilterBySite(siteName);
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onSaveArticle) {
      onSaveArticle(article);
    }
  };

  return (
    <Card sx={{ backgroundColor: "white", boxShadow: 3, borderRadius: 0, p: 1.5 }}>
      <CardActionArea
        component={Link}
        to={`/article/${article.id}`}
        sx={{ display: 'flex', alignItems: 'center', p: 1 }}
      >
        {article.image && (
          <CardMedia
            component="img"
            image={article.image}
            alt={article.TITLE}
            sx={{
              width: 120,
              height: 80,
              objectFit: 'cover',
              flexShrink: 0
            }}
          />
        )}
        <CardContent sx={{ flex: 1, ml: 2, py: 1.5 }}>
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{ wordBreak: "break-word", overflowWrap: "break-word", lineHeight: 1.4 }}
          >
            {article.TITLE}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            {formattedDate}
          </Typography>
        </CardContent>
      </CardActionArea>

      {/* SITE_NAMEとハートボタン */}
      <Box sx={{ mt: 2, pl: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton size="small" onClick={handleSaveClick}>
          {isSaved ? (
            <FavoriteIcon color="error" fontSize="small" />
          ) : (
            <FavoriteBorderIcon fontSize="small" />
          )}
        </IconButton>
        <Chip
          label={siteName}
          size="small"
          sx={{
            fontSize: "0.7rem",
            height: "20px",
            cursor: "pointer",
            fontWeight: "bold",
            backgroundColor: siteName === selectedSite ? "#007bff" : "default",
            color: siteName === selectedSite ? "white" : "black"
          }}
          onClick={handleSiteClick}
        />
      </Box>
    </Card>
  );
};

export default NewsCard;
